// extracted by mini-css-extract-plugin
export default {"formLabel":"formLabel__KAYfKxfRC9xA"};